var map = {
	"./checkmark.svg": "A/pN",
	"./close-grey.svg": "XFyV",
	"./close-purple.svg": "5Dce",
	"./close-white.svg": "YvL2",
	"./close.svg": "XrMM",
	"./dropdown.svg": "TjTj",
	"./menu-purple.svg": "oNkJ",
	"./menu-white.svg": "eHXZ",
	"./menu.svg": "mMOB",
	"./tick.svg": "Jpyn",
	"./uprise-dropdown-default.svg": "iP38",
	"./uprise-dropdown-theme-color.svg": "0FwE",
	"./uprise-dropdown.svg": "2zbq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pTVF";